<template>
    <div class="pull-down py-2" :class="{open: isOpen}">
        <header class="pull-down-header d-flex align-items-center" @click="toggle">
            <div class="icon bg-body rounded-circle shadow p-4 mr-6">
                <span></span>
                <span></span>
            </div>
            
            <slot name="title"></slot>
        </header>

        <div class="pull-down-content-wrapper pl-8 mb-4">
            <div class="pull-down-content pt-4 pr-4 pl-4">
                <slot></slot>
            </div>
        </div>
        <hr v-if="withSeparator" class="my-0 ml-9 mr-4">
    </div>
</template>

<script>
    export default {
        props: {
            withSeparator: Boolean,
        },

        data: function () {
            return {
                isOpen: false,
                content: null,
                contentWrapper: null,
            }
        },

        mounted: function () {
            this.content = $(this.$el).find('.pull-down-content');
            this.contentWrapper = $(this.$el).find('.pull-down-content-wrapper');
        },

        methods: {
            toggle: function () {
                this.contentWrapper.css({
                    'height': this.isOpen ? 0 : this.content.outerHeight(),
                });
                this.isOpen = !this.isOpen;
            },
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    .pull-down{

        .pull-down-header{
            cursor: pointer;

            .icon{
                position: relative;
                width: 1rem;
                height: 1rem;

                span{
                    width: 1rem;
                    height: 0rem;
                    display: block;
                    border-top: .1rem solid $green-light;
                    border-bottom: .1rem solid $green-light;

                    position: absolute;
                    left: 50%;
                    top: 50%;

                    transition: transform .5s ease-in-out;

                    &:nth-child(1) {
                        transform: translate3d(-50%, -50%, 0);
                    }

                    &:nth-child(2) {
                        transform: translate3d(-50%, -50%, 0) rotate3d(0, 0, 1, 90deg);
                    }
                }
            }

        }

        &.open .icon span{
            transform: translate3d(-50%, -50%, 0) rotate3d(0, 0, 1, 180deg) !important;
        }

        .pull-down-content-wrapper{
            height: 0;
            overflow: hidden;
            transition: height .5s ease-in-out;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PullDown.vue